export default __webpack_public_path__ + "static/media/reserveat-logo-text-small.997e9dd7.png";